import get from 'lodash/get';
import {
	UNSUPPORTED_FIELD,
	QUERY_ERROR,
} from '@atlassian/jira-issue-create-common-types/src/common/constants/graphql-field-types.tsx';
import type {
	GraphqlErrorExtensions,
	GraphqlErrorExtension,
} from '@atlassian/jira-issue-create-common-types/src/common/types/index.tsx';
import type { UnsupportedFieldsGql, CreateConfigQueryResponse } from '../../types/index.tsx';

export const getGqlUnsupportedFields = (errors: GraphqlErrorExtensions): UnsupportedFieldsGql => {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const unsupportedFields: Record<string, any> = {};
	let isRequiredFieldTypeSupported = true;
	errors.forEach(({ identifier, extensions }: GraphqlErrorExtension) => {
		const { __typename: gqlType } = extensions[0] || {};
		if (
			gqlType === UNSUPPORTED_FIELD &&
			// @ts-expect-error - TS2339 - Property 'fieldName' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
			typeof extensions[0].fieldName === 'string' &&
			// @ts-expect-error - TS2339 - Property 'isRequiredField' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
			typeof extensions[0].isRequiredField === 'boolean' &&
			// @ts-expect-error - TS2339 - Property 'fieldType' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
			typeof extensions[0].fieldType === 'string'
		) {
			// @ts-expect-error - TS2339 - Property 'fieldName' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'. | TS2339 - Property 'fieldType' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'. | TS2339 - Property 'isRequiredField' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
			const { fieldName, fieldType, isRequiredField } = extensions[0];
			unsupportedFields[identifier] = {
				gqlType,
				fieldId: identifier,
				fieldName,
				fieldType,
				isRequired: isRequiredField,
			};
			if (isRequiredField) {
				isRequiredFieldTypeSupported = false;
			}
		}
	});
	return {
		unsupportedFields,
		isRequiredFieldTypeSupported,
	};
};

export const getQueryErrorMessage = (data: CreateConfigQueryResponse): string => {
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const gqlIssueCreateFieldsType = get(data, 'jiraIssueCreateFields.__typename', '' as string);
	const queryErrorMessage = get(data, 'jiraIssueCreateFields.message', '');
	if (gqlIssueCreateFieldsType === QUERY_ERROR && Boolean(queryErrorMessage)) {
		return queryErrorMessage;
	}

	const gqlIssueCreateLayoutType = get(data, 'jiraIssueCreateLayout.__typename', '');
	const issueCreateFieldsQueryErrorMessage = get(
		data,
		'jiraIssueCreateFields.errors[0].extensions[0].message',
		'',
	);
	if (gqlIssueCreateLayoutType === QUERY_ERROR && Boolean(issueCreateFieldsQueryErrorMessage)) {
		return issueCreateFieldsQueryErrorMessage;
	}
	return '';
};
